import { EnumEnquiryCotationStatus } from '@simplyfly/shared';
export const getEnumEnquiryCotationStatusLabel = (status: EnumEnquiryCotationStatus): string => {
  switch (status) {
    default:
      return status;
    case EnumEnquiryCotationStatus.toContact:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.TO_CONTACT';
    case EnumEnquiryCotationStatus.waitingForAnswer:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.WAITING_FOR_ANSWER';
    case EnumEnquiryCotationStatus.answered:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.ANSWERED';
    case EnumEnquiryCotationStatus.rejected:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.REJECTED';
    case EnumEnquiryCotationStatus.confirmed:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.CONFIRMED';
    case EnumEnquiryCotationStatus.cancelled:
      return 'ENQUIRIES.AIRLINES_QUOTING.STATUSES.CANCELLED';
  }
};
